export default __webpack_public_path__ + "static/media/dacast.56a27f71.svg";